const signupFormFunction = () => {
    // Add langauge code to country names with non english symbols for ADA
    const languagesArray = [
        { id: '387', language: 'bs' },
        { id: '357', language: 'el' },
        { id: '389', language: 'mk' },
        { id: '7', language: 'ru' }
    ];
    languagesArray.forEach((language, i) => {
        const languageItem = $('.country-list .country[data-dial-code="' + language.id + '"]');
        const languageTestElem = languageItem.find('.country-name');

        languageTestElem.attr('lang', language.language);
    });

    // Toggle the display of the signup form
    $(document).on('click', '.js-signup-form-toggle', function(e) {
        e.preventDefault();
        
        const formWrapper = $(this).closest('.c-signup-form__btn-container').siblings('.c-signup-form__form-wrapper');

        formWrapper.stop().slideToggle();
    });

    $('.survey .fieldBlock').each(function() {
        var $fieldBlock = $(this);
        var $input = $fieldBlock.find('input');
        var $fieldBlockText = $fieldBlock.find('.fieldBlockText');

        $input.on('input', function() {
            if ($input.val().trim() !== '') {
                $fieldBlockText.fadeOut();
            } else {
                $fieldBlockText.fadeIn();
            }
        });
    });

    $('.survey .questionBlock').each(function() {
        var $questionBlock = $(this);
        var $input = $questionBlock.find('textarea');
        var $questionBlockText = $questionBlock.find('.questionText');

        $input.on('input', function() {
            if ($input.val().trim() !== '') {
                $questionBlockText.fadeOut();
            } else {
                $questionBlockText.fadeIn();
            }
        });
    });
}